module.exports = __webpack_public_path__ + "static/media/background.3c04ed42.jpeg";